import { Typography } from "@mui/material";
import React, { memo } from "react";

import { useTheme } from "@mui/material/styles";

function KsbBoxHeader({
  title,
  options,
  flipAssignment,
  setFlipAssignment,
  workloadFlip,
  setWorkloadFlip,
}) {
  const theme = useTheme();

  return (
    <>
      <Typography variant="h4" color={theme.palette.text.blue} noWrap={true}>
        {title}
      </Typography>
    </>
  );
}
export default memo(KsbBoxHeader);
